import axios from 'axios';
import Api from '../api/ApiUrl';

const API_URL = `${Api}/api/v1`;
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const SettingsService = {
  createAppShareLink: async (data) => {
    console.log(data)
    const response = await axios.post(`${API_URL}/appShareLink`, data,config);
    return response.data;
  },
  getAllAppShareLinks: async () => {
    const response = await axios.get(`${API_URL}/appShareLink`,config);
    console.log(response)

    return response.data;
  },
  getAppShareLinkById: async (id) => {
    const response = await axios.get(`${API_URL}/appShareLink/${id}`,config);
    return response.data;
  },
  updateAppShareLink: async (id, data) => {
    const response = await axios.patch(`${API_URL}/appShareLink/${id}`, data,config);
    return response.data;
  },
  deleteAppShareLink: async (id) => {
    const response = await axios.delete(`${API_URL}/appShareLink/${id}`,config);
    return response.data;
  },

  createPhoneNumber: async (data) => {
    const response = await axios.post(`${API_URL}/phoneNumber`, data,config);
    return response.data;
  },
  getAllPhoneNumbers: async () => {
    const response = await axios.get(`${API_URL}/phoneNumber`,config);
    return response.data;
  },
  getPhoneNumberById: async (id) => {
    const response = await axios.get(`${API_URL}/phoneNumber/${id}`,config);
    return response.data;
  },
  updatePhoneNumber: async (id, data) => {
    const response = await axios.patch(`${API_URL}/phoneNumber/${id}`, data,config);
    return response.data;
  },
  deletePhoneNumber: async (id) => {
    const response = await axios.delete(`${API_URL}/phoneNumber/${id}`,config);
    return response.data;
  },

  createPrivacyPolicy: async (data) => {
    const response = await axios.post(`${API_URL}/privacyPolicy`, data,config);
    return response.data;
  },
  getAllPrivacyPolicies: async () => {
    const response = await axios.get(`${API_URL}/privacyPolicy`,config);
    return response.data;
  },
  getPrivacyPolicyById: async (id) => {
    const response = await axios.get(`${API_URL}/privacyPolicy/${id}`,config);
    return response.data;
  },
  updatePrivacyPolicy: async (id, data) => {
    const response = await axios.patch(`${API_URL}/privacyPolicy/${id}`, data,config);
    return response.data;
  },
  deletePrivacyPolicy: async (id) => {
    const response = await axios.delete(`${API_URL}/privacyPolicy/${id}`,config);
    return response.data;
  },

  createSocialMediaLink: async (data) => {
    const response = await axios.post(`${API_URL}/socialMediaLink`, data,config);
    return response.data;
  },
  getAllSocialMediaLinks: async () => {
    const response = await axios.get(`${API_URL}/socialMediaLink`,config);
    return response.data;
  },
  getSocialMediaLinkById: async (id) => {
    const response = await axios.get(`${API_URL}/socialMediaLink/${id}`,config);
    return response.data;
  },
  updateSocialMediaLink: async (id, data) => {
    const response = await axios.patch(`${API_URL}/socialMediaLink/${id}`, data,config);
    return response.data;
  },
  deleteSocialMediaLink: async (id) => {
    const response = await axios.delete(`${API_URL}/socialMediaLink/${id}`,config);
    return response.data;
  },
};

export default SettingsService;
